import './Main.css';
import './CSS/Home.css';
import {HeaderLinks, FooterLinks} from "./ToolBox.jsx"
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

//For the homepage picture slides
const ImageSliders = () => {
  const images = [
    "/Images/AboutImgs/Preacher.jpg",
    "/Images/Sunday_School.jpg",
    "/Images/AboutImgs/ChildChurch Meet.jpg",
    "/Images/Wednesday.jpg",
  ];

  //establishing variables
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {  
      nextSlide();
    }, 7000); // 7 second timer

    return () => clearInterval(interval); // cleanup to prevent stacking
  }, []);
  const nextSlide = () => {
    setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1)); //uses pointers to go to the next image. if at last picture, it goes to the first
  };
  return (
    <div id="picSide">
      <img className="picBorder fade" src={images[index]} alt="slideShow" />
    </div>
  );
};

const message = [
  "Greetings from Pastor Vince and Jill.",
  "We are so excited to see you found our digital home!",

  "Our ministry has its arms stretched out, waiting to embrace you just as you are.",
  "You may be saying to yourself, 'Pastor, if you only knew the things I’ve done, you wouldn't want me in your church.' Don't worry about your past; I have good news for you.",
  "God is a God of love and compassion, and we are here to strengthen the saints and see the power of the gospel change lives.",
  "Our mission is to restore God's people through sound doctrine and biblical principles. It is our hope to help you find the peace that comes from knowing our Lord Jesus Christ.",
  "So please be our special guest this Sunday at 11:00 a.m."
]
const message2 = [
  "Our worship service provides an uplifting experience and encouraging message. We'd love to meet you.",
  "Our Sunday School classes serve all age groups, offering interactive lessons for children and engaging Bible studies for adults.",
  "Join us each Wednesday night for a time to connect with others of all ages through fellowship, sharing a meal, and hearing an inspiring message.",
]
function TextMaker({paragraph}){
  return paragraph.map((line, i) =>(
    <p id="Message" key={i}>{line}</p>
  ));
}

const WriteUp = () => {
  return(
    <div className="dividers">
      <img className="picBorder" id="pastorPic" src="/Images/PastorPic.JPEG" alt="Our Pastor"/>
      <div className="MessageBox">
        <TextMaker paragraph={message}/>
      </div>
    </div>
  );
}


export default function HomePage() {
  return (
    <div className="backgroundGradient">
      <Link to="/"><img src="/Images/Chapel Logo.png" alt="Pennington Chapel" /></Link>
      <HeaderLinks />
      <div class="container">
        <img id="theChurch" className="picBorder" src="/Images/Church.jpg" alt="Chapel"/>
        <div class="overlay">We invite you to Pennington Chapel!</div>
      </div>
      <div className="banner">
        <h2 className="bannerText">We're excited you're here!</h2>
        <p id="subText">Everyone is welcome</p>
      </div>
      <WriteUp />
      <div class="banner">
        <p id="subText">Join us as we grow in faith together! There's something for everyone</p>
      </div>
      <div className="dividers">
        <ImageSliders />
        <div className="MessageBox">
          <TextMaker paragraph={message2}/>
        </div>
      </div>
      <div className="dividers">
        <div>
          <p className="KOheader">Join us!</p>
          <div className="paragraph">
              <p><span className="infoHeader">Sunday School:</span> 10:00 a.m.</p>
              <p><span className="infoHeader">Sunday Morning Worship:</span> 11:00 a.m.</p>
              <p><span className="infoHeader">Children's Church:</span> During Morning Worship</p>
              <p><span className="infoHeader">Wednesday Night Fellowship:</span> 6:00 p.m.</p>
          </div>
        </div>
        <p id='homeVerse'>"That I may know Him and the power of His resurrection, and the fellowship of His sufferings, being conformed to His death." (Philippians 3:10 NKJV)</p>
      </div>
      <p className="KOheader">Mission</p>
      <p className="paragraph">To know God and to make Him known</p>
      <FooterLinks />
    </div>
  );
}